// @flow

import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import PuzzleField from './PuzzleField';
import PuzzleStack from './PuzzleStack';
import HelpButton from './HelpButton';
import type { PieceData, PiecesData, PlacePuzzlePiece } from './types';

type Props = {
  piecesData: PiecesData,
  placePuzzlePiece: PlacePuzzlePiece,
  activePiece: PieceData,
  level: number,
  fieldWidth: number,
  helpAudio: string,
  assetPath: string,
};

type State = {
  transition: boolean,
};

class Container extends Component<Props, State> {
  constructor(props: Props): void {
    super(props);
    this.state = {
      transition: false,
    };
  }

  enableTransition(): void {
    this.setState({
      transition: true,
    });
  }

  componentDidMount(): void {
    this.enableTransition();
  }

  componentDidUpdate(prevProps: Props): void {
    if (this.props.level !== prevProps.level) {
      this.enableTransition();
    }
  }

  render(): React$Element<any> {
    const {
      piecesData,
      placePuzzlePiece,
      activePiece,
      fieldWidth,
      helpAudio,
      assetPath,
    } = this.props;
    const { transition } = this.state;

    return (
      <CSSTransition
        in={transition}
        classNames="puzzle__field-transition"
        timeout={300}
        onEntered={() => {
          this.setState({
            transition: false,
          });
        }}
      >
        <div className="flex h-full landscape:items-center">
          <div className="p-1 pt-3 relative flex landscape:flex-row portrait:flex-col portrait:w-auto mx-auto" id="puzzle-container">
            <HelpButton
              activePiece={activePiece}
              placePuzzlePiece={placePuzzlePiece}
              helpAudio={helpAudio}
              fieldWidth={fieldWidth}
              assetPath={assetPath}
            />
            <PuzzleField
              piecesData={piecesData}
              placePuzzlePiece={placePuzzlePiece}
              fieldWidth={fieldWidth}
            />
            <PuzzleStack activePiece={activePiece} fieldWidth={fieldWidth} />
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default Container;
